import React from 'react';
import { Box } from '@mui/material';

const Line = ({ 
  width = 100,
  height = 2,
  borderColor = '#000000',
  borderWidth = 2,
  opacity = 1,
  direction = 'horizontal' // horizontal or vertical
}) => {
  const isHorizontal = direction === 'horizontal';
  
  return (
    <Box
      sx={{
        width: '100%',
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        opacity
      }}
    >
      <Box
        sx={{
          width: isHorizontal ? '100%' : `${borderWidth}px`,
          height: isHorizontal ? `${borderWidth}px` : '100%',
          backgroundColor: borderColor,
          borderRadius: '1px'
        }}
      />
    </Box>
  );
};

export default Line;